<div #pointer class="pointer"></div>